export default __webpack_public_path__ + "static/media/InstagramH.abc78fe4.svg";